module.exports = __webpack_public_path__ + "media/images/application/icons/icon-update-0a5def1b878264dcd299bd365a132349.svg";